export enum AdminInvitationStatus {
  ACCEPTED = 'ACCEPTED',
  PENDING = 'PENDING',
}
